import get from 'lodash/get';
import { createSelector } from 'reselect';

export const defaults = {
    preferences: {},
    messagesTexts: {},
    context: {},
};

const selectContext = (state) => state.context || defaults.context;

export const createDropdownMessagesTexts = createSelector([selectContext], (context) =>
    get(context, 'messagesTexts.myListing', defaults.messagesTexts)
);

export const createDropdownPreferences = createSelector([selectContext], (context) =>
    get(context, 'preferences.myListing', defaults.preferences)
);
